var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "a_slide_show",
    d: "M0 0h12.75v6.8H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.275.85a.426.426 0 0 0-.425.425v11.9c0 .235.191.425.425.425h17.85c.234 0 .425-.19.425-.425v-11.9a.426.426 0 0 0-.425-.425H1.275zm17.85 13.6H1.275A1.277 1.277 0 0 1 0 13.175v-11.9C0 .572.572 0 1.275 0h17.85c.703 0 1.275.572 1.275 1.275v11.9c0 .703-.572 1.275-1.275 1.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.775 20.4a.425.425 0 0 1-.425-.425v-5.95a.425.425 0 0 1 .85 0v5.95c0 .235-.19.425-.425.425"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.4 13.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b_slide_show",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a_slide_show"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.325 6.8a.427.427 0 0 1-.3-.124l-5.65-5.65-5.65 5.65a.426.426 0 0 1-.6-.602l5.95-5.95a.426.426 0 0 1 .6 0l5.95 5.95a.426.426 0 0 1-.3.726",
    mask: "url(#b_slide_show)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.975 4.25H.425a.425.425 0 0 1 0-.85h19.55a.425.425 0 0 1 0 .85"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6f107495.svg";
export { ForwardRef as ReactComponent };